export default function (vue) {
  this.vue = vue
  this.copy = function (text) {
    if (navigator.clipboard !== undefined) {
      navigator.clipboard.writeText(text)
      window.getSelection().removeAllRanges()
    } else {
      return false
    }
    vue.$notifications.notify({
      message: vue.translate('clipboard.value_save_buffer'),
      icon: 'mdi mdi-information-outline',
      horizontalAlign: 'center',
      verticalAlign: 'top',
      type: 'info',
      timeout: 1000
    })
  }
}
